

export  class UserCountyId {
  constructor(
    public userId ?: number,
    public serviceCounty?: number,
    public recordVersion?: number,
  ){}
}



// WEBPACK FOOTER //
// ./src/app/shared/model/UserCountyId.ts